import React from 'react';
import { Type, Shield } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 bg-muted/20 border-t border-border/50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Logo and tagline */}
            <div className="flex flex-col items-center md:items-start gap-3">
              <div className="flex items-center gap-3">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                  <Type className="h-4 w-4" />
                </div>
                <span className="font-display text-lg font-bold text-foreground">
                  CaseFlip
                </span>
              </div>
              <p className="text-sm text-muted-foreground text-center md:text-left max-w-xs">
                Free online text case converter. Fast, private, and works in your browser.
              </p>
            </div>

            {/* Privacy badge */}
            <div className="flex items-center gap-2 text-sm text-muted-foreground bg-muted/50 px-4 py-2 rounded-full">
              <Shield className="h-4 w-4 text-primary" />
              <span>Your text is never stored or shared</span>
            </div>

            {/* Links */}
            <div className="flex items-center gap-6 text-sm">
              <a 
                href="#" 
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Privacy Policy
              </a>
              <a 
                href="#" 
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Terms of Use
              </a>
              <a 
                href="#" 
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Contact
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 pt-6 border-t border-border/30 text-center">
            <p className="text-sm text-muted-foreground">
              © {currentYear} CaseFlip. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
